class Login{

    constructor(){
        this.Login = [
            {
                id: 0
                , email: "bill@matranx.com.tw"
                , password: "123456"
                , name: "Bill"
                , img: "@/assets/img/avatars/avatar-5.jpg"
            },
            {
                id: 1
                , email: "myeasy@matranx.com.tw"
                , password: "123456"
                , name: "Jerry"
                , img: "@/assets/img/avatars/avatar-5.jpg"
            }
        ];

        this.UserData = null;
    }

    async login(obj){

        var response = {
            code: -101
            , message: "Email Not Exisit"
            , data: null
        }

        for(var i=0;i<this.Login.length;i++){
            if(
                this.Login[i].email==obj.email
            ){
                if(this.Login[i].password==obj.password){
                    response.code = 200;
                    response.message = "Login Success";
                    response.data = this.Login[i];
                }else{
                    response.code = -100;
                    response.message = "Password Error";
                }
            }
        }

        return response;
    }

    logout(obj){
        this.UserData = null;
    }

    setUserData(obj){
        this.UserData = obj;
    }

    getUserData(){
        return this.UserData;
    }

}

export default Login;